const nomenclatures = {
    namespaced: true,
    state: {
        year: null,
        search: null,
        tableOptions: {
            page: 1,
            itemsPerPage : 10,
            sortBy : [ "code" ],
            sortDesc : [ false ],
            groupBy : [],
            groupDesc : [],
            multiSort : false,
            mustSort : false
        },
    },
    mutations: {
        SET_YEAR (state, payload) {
            state.year = payload;
        },
        SET_TABLE_SEARCH (state, payload) {
            state.search = payload;
        },
        SET_TABLE_OPTION (state, payload) {
            state.tableOptions = payload;
        },
        SET_TABLE_OPTION_PAGE (state, payload) {
            state.tableOptions.page = payload;
        }
    },
    getters: {
        getYear: (s) => s.year,
        getTableSearch: (s) => s.search,
        getTableOptions: (s) => s.tableOptions,
    }
}

export default nomenclatures;